<script>
export default {
  methods: {
    logUserSignedIn(pin) {
      if (this.$ga) {
        this.$ga.set('dimension1', pin)
      }
    }
  }
}
</script>
